import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import {environment} from '../../../environments/environment';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { LookupMaster } from '../models';

@Injectable({
  providedIn: 'root'
})
export class LookupMasterService{
    constructor(
        private http: HttpClient,
        private apiService: ApiService
    ) { }

   
     /**
    * This method is used to get the search results of lookup master
    * based on the parameters.
    *
    * @param  pageNo  current page number
    * @param  pageSize Number of records per page
    * @param  sortField field needed to sort
    * @param  sortOrder whether the sorting field is ascending or descending
    * @param  appliedFilters appliedFilters
    * @return      json result
    */
      public searchLookupMaster(pageNo:number,pageSize:number,sortField:string,sortOrder:string,appliedFilters:{field:string,matchMode:string,value:string}[]=[]):Observable<any> {
        return this.apiService.get(`LookupMaster/SearchLookupMaster?pageNo=${pageNo}&pageSize=${pageSize}&sortField=${sortField}&sortOrder=${sortOrder}&appliedFilters=${appliedFilters}`)
      }
  
  
      /**
      * This method is used to get all lookup master records, there is no parameter
      *
      * @return      json result
      */
       public getAllLookupMasters(lookupMasterSearchParam:IGlobalSearchParam):Observable<any> {
        console.log(lookupMasterSearchParam);
        return this.apiService.post(`LookupMaster/SearchLookupMaster`,lookupMasterSearchParam)
      }
  
      /**
      * This method is used to get individual lookup master record based on the lookupid
      *
      * @param  lookupId  
      * @return      json result
      */
       public getLookupMasterById(lookupId:number):Observable<any> {
          return this.apiService.get(`LookupMaster/${lookupId}`)
      }
  
      /**
      * This method is used to post/add new lookup master record
      *
      * @param  LookupMaster object which contains the lookup record values
      * @return      json result
      */
       public postLookupMaster(lookupMaster:LookupMaster):Observable<any> {
          return this.apiService.post(`LookupMaster`, lookupMaster)
      }
  
  
      /**
      * This method is used to update the existing lookup master record
      *
      * @param  Lookup Id 
      * @param  LookupMaster object which contains the lookup record values
      * @return      json result
      */
       public updateLookupMaster(lookupId:number, lookupMaster:LookupMaster):Observable<any> {
          return this.apiService.put(`LookupMaster/${lookupId}`, lookupMaster)
      }
  
  
      /**
      * This method is used to delete the existing lookup master record
      *
      * @param  Lookup Id
      * @return      json result
      */
       public deleteLookupMaster(lookupId:number):Observable<any> {
          return this.apiService.delete(`LookupMaster/${lookupId}`)
      }

      public getAllCategories():Observable<any> {
        return this.apiService.get(`lookupcategory`);
      }

      public ExportLookupMasterResult(lookupSearchParam:IGlobalSearchParam):Observable<any> {
        return this.http.post(`${environment.apiRoot}LookupMaster/ExportLookupMaster`, lookupSearchParam,
        {  
            responseType: 'blob',
            observe: 'response'
         });
      }

      public onLookUpOrderCheck(categoryId: number,lookupOrder:number): Observable<any> {
        return this.apiService.get(`LookupMaster/LookupOrderCheck?categoryId=${categoryId}&lookupOrder=${lookupOrder}`);
      }

      public GetNextLookupOrder(categoryId: number): Observable<any> {
        return this.apiService.get(`LookupMaster/GetNextLookupOrder?categoryId=${categoryId}`);
      }

      /**
      * This method is used to get all lookup master records based on the lookup category id
      *
      * @param  lookupCategoryId  
      * @return      json result
      */
       public getLookupMasterByCategoryId(lookupCategoryId:number):Observable<any> {
        return this.apiService.get(`LookupMaster/LookupMasterByCategoryId/${lookupCategoryId}`)
    }
  
}
